const cardItems = [
  {
    id: 1,
    title: '吃瓜黑料网站终极导航：从入门到精通',
    desc: '全面解析吃瓜网站的生态体系，让你成为最会吃瓜的人',
    tag: '攻略',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20coral%20and%20soft%20amber%20gradients%2C%20modern%20minimalist%20aesthetic%2C%20geometric%20shapes%20suggesting%20navigation%20and%20exploration%2C%20clean%20atmospheric%20lighting%2C%20no%20text&width=640&height=420&seq=card-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '51黑料网站：十年发展史与影响力分析',
    desc: '回顾51黑料网站从创立到成为行业标杆的完整历程',
    tag: '深度',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20editorial%20composition%20with%20warm%20terracotta%20and%20deep%20amber%20tones%2C%20historical%20narrative%20feel%2C%20overlapping%20geometric%20timeline%20elements%2C%20soft%20dramatic%20lighting%2C%20no%20text&width=640&height=420&seq=card-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '91黑料网站独家内容风格深度解析',
    desc: '为什么91黑料网站的深度报道总能引发广泛讨论？',
    tag: '分析',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20burgundy%20and%20coral%20gradients%2C%20analytical%20and%20investigative%20mood%2C%20geometric%20magnifying%20glass-like%20elements%2C%20soft%20glow%20accents%2C%20no%20text&width=640&height=420&seq=card-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '网红翻车防坑指南：如何识别虚假宣传',
    desc: '从黑料网站学会辨别技巧，避免被网红营销套路收割',
    tag: '实用',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20amber%20and%20soft%20rose%20gradients%2C%20educational%20and%20guiding%20mood%2C%20geometric%20shield-like%20elements%2C%20clean%20modern%20aesthetic%2C%20no%20text&width=640&height=420&seq=card-4-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '娱乐圈资本局：明星背后的对赌协议揭秘',
    desc: '影视公司对赌协议如何影响明星行为与作品质量？',
    tag: '揭秘',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20composition%20with%20deep%20burgundy%20and%20amber%20gradients%2C%20corporate%20and%20financial%20mood%2C%20abstract%20geometric%20shapes%20suggesting%20contracts%20and%20deals%2C%20dramatic%20lighting%2C%20no%20text&width=640&height=420&seq=card-5-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '最新黑料网站推荐：2026年新兴吃瓜平台',
    desc: '盘点今年新冒头的优质吃瓜平台和黑料来源渠道',
    tag: '推荐',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20coral%20and%20soft%20terracotta%20gradients%2C%20fresh%20and%20discovery%20mood%2C%20geometric%20star-like%20elements%2C%20inviting%20atmospheric%20lighting%2C%20no%20text&width=640&height=420&seq=card-6-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            精选图文
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            深度好文推荐，吃瓜也要有营养
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-48 bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}